import {observer} from 'mobx-react-lite'
import React from 'react'
import {ChatMessageJSON} from 'yougile-model'
import {Loader} from '@components/common/base/loader'
import {useLoadedLazyChatMessages} from '@containers/hooks'
import {useChatStore} from '../../chat-store'

interface Props {
  message: ChatMessageJSON
}

interface LazyMessageProps {
  nextMessage: number
  forMessage: number
  type: 'before' | 'after'
}

export const LazyMessagePlaceholder = observer(({message}: Props) => {
  const [state] = useChatStore()
  const messages = state.hub?.chat?.messages ?? new Map()
  const {forMessage, type, nextMessage} = (message.properties ??
    {}) as unknown as LazyMessageProps
  const needToLoad = !messages.has(nextMessage)
  useLoadedLazyChatMessages({
    enabled: needToLoad,
    hub: state.hub,
    forMessage,
    type
  })
  if (!needToLoad) {
    return null
  }
  return (
    <div className="flex items-center justify-center w-full py-6">
      <Loader size="small" />
    </div>
  )
})
